import angular from 'angular';

angular.module('neurotecAbisWebClientApp')
	.directive('zoom', () => ({
		template: require('../../../views/directives/latent-editor/zoom.html'),
		restrict: 'E',
		replace: true,
		scope: {
			zoom: '='
		}
	}));
